import { useState } from 'react';
import { MessageSquare, Plus } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { leadService } from '../../services/api';
import { Button, Toast } from '../../components/ui';

const AddNoteCard = ({ leadId, canAddNote, onAdded }) => {
  const { dark } = useTheme();
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState(null);

  const handleAdd = async () => {
    if (!text.trim()) return;
    setSubmitting(true);
    try {
      await leadService.addNote(leadId, { text: text.trim() });
      setText('');
      setToast({ msg: 'Note added', type: 'success' });
      if (onAdded) await onAdded();
    } catch (err) {
      setToast({ msg: err.response?.data?.message || err.message || 'Failed to add note', type: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  if (!canAddNote) return null;

  return (
    <div style={{ background: dark ? '#0F172A' : '#F8FAFC', borderRadius: 14, border: `1px solid ${dark ? '#334155' : '#E2E8F0'}`, padding: '16px 20px', marginBottom: 20 }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <div style={{ fontSize: 13, fontWeight: 700, color: dark ? '#F1F5F9' : '#0F172A', display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
        <MessageSquare size={14} color="#3B82F6" /> Add Note
      </div>
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Add a note about this lead's status or next steps..."
        rows={3}
        style={{
          width: '100%', padding: '10px 12px', borderRadius: 8,
          border: `1px solid ${dark ? '#475569' : '#D1D5DB'}`,
          background: dark ? '#1E293B' : '#fff',
          color: dark ? '#F1F5F9' : '#0F172A',
          fontSize: 13, outline: 'none', boxSizing: 'border-box',
          resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5,
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
        <Button size="sm" icon={Plus} disabled={!text.trim() || submitting} onClick={handleAdd}>
          {submitting ? 'Adding...' : 'Add Note'}
        </Button>
      </div>
    </div>
  );
};

export default AddNoteCard;
